import { render, staticRenderFns } from "./ScreenRegalados.vue?vue&type=template&id=0265e9ac"
import script from "./ScreenRegalados.vue?vue&type=script&lang=js"
export * from "./ScreenRegalados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports